import styles from './index.less';
import { Popup, CheckList } from 'antd-mobile';
import { FC, useEffect, useState } from 'react';
import { CheckListValue } from 'antd-mobile/2x/es/components/check-list';
import { useModel } from '@umijs/max';
import { querySetDefaultHouse } from '@/service/house';
import { Toast } from 'react-vant';
interface ISelectCommunityProps {
  visible: boolean;
  close: (visible: boolean) => void;
}
const SelectCommunity: FC<ISelectCommunityProps> = (props) => {
  const { visible, close } = props;
  // const [searchValue, setSearchValue] = useState('');
  const [selectCommunityValue, setSelectCommunityValue] = useState<
    CheckListValue[]
  >([]);
  const [communityList, setCommunityList] = useState<any[]>([]);

  const { roomList, queryInformation, defaultRoom, bindInformation, ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation,
      roomList: model.roomList,
      queryInformation: model.queryInformation,
      defaultRoom: model.defaultRoom,
      bindInformation: model.bindInformation,
    }),
  );
  useEffect(() => {
    if (visible) {
      setCommunityList(roomList);
      setSelectCommunityValue([roomList[0]?.roomId]);
    }
  }, [visible]);

  const handleClose = () => {
    close(false);
  };


  const handleChange = (value: CheckListValue[]) => {
    setSelectCommunityValue(value);
  };

  const handleConfirm = () => {
    console.log(selectCommunityValue[0].toString())
      querySetDefaultHouse(selectCommunityValue[0].toString()).then(async (res) => {
        if (res?.code === 200) {
          Toast.success('设置切换成功！');
          
          await queryInformation();
          await handleClose();
        }
      });
  };


  return (
    <Popup
      visible={visible}
      onClose={handleClose}
      position={'top'}
      bodyClassName={styles.community}
    >
      {/* <SearchBar
        onChange={(value) => handleSearch(value)}
        value={searchValue}
        className={styles.search}
        placeholder={'搜索小区名称'}
      /> */}
      {/* <div className={styles.title}>附近小区</div> */}
      <CheckList
        className={styles.list}
        onChange={(value) => handleChange(value)}
        value={selectCommunityValue}
      >
        {communityList.map((item) => (
          <CheckList.Item key={item.sequenceNbr} value={item.roomId}>
            {`${item.communityName}-${item.regionName}- ${item.floorName}-${item.roomName}`}
          </CheckList.Item>
        ))}
      </CheckList>
      <div className={styles.btn}>
        <div className={styles.cancel} onClick={handleClose}>
          取消
        </div>
        <div onClick={handleConfirm} className={styles.confirm}>
          确认
        </div>
      </div>
    </Popup>
  );
};
export default SelectCommunity;
